import { lazy } from "react";

export { RESIGNATION_REQUEST_PATH } from "./path";
export const ResignationRequestPage = lazy(() => import("./page"));
